export function loadState() {
  try {
    const serializedState = localStorage.getItem('state');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
}

export function saveState(state) {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('state', serializedState);
  } catch (err) {
    // Ignore writing errors
  }
}

export function setParam(param, value) {
  try {
    localStorage.setItem(param, value);
  } catch (err) {
    // Ignore writing errors
  }
}

export function getParam(param) {
  try {
    return localStorage.getItem(param);
  } catch (err) {
    return undefined;
  }
}



// WEBPACK FOOTER //
// ./src/localStorage.js